import { LinkTitle, RelatedArticle, WrapLink } from "../style/styled";

export function CompRelatedArticle() {
  return (
    <>
      <LinkTitle>관련 기사 목록</LinkTitle>
      <WrapLink>
        <RelatedArticle>
          <a href="https://news.sbs.co.kr/news/endPage.do?news_id=N1006599029">
            역대 대선 다 맞춘 '천기누설 동네'는 어디?
          </a>
        </RelatedArticle>
        <RelatedArticle>
          <a href="https://news.sbs.co.kr/news/endPage.do?news_id=N1006622781">
            2030 밀집 동네 표심, 21대 총선부터 '변화'
          </a>
        </RelatedArticle>
        <RelatedArticle>
          <a href="https://news.sbs.co.kr/news/endPage.do?news_id=N1006622828">
            "진보? 보수? 됐어요!"…2030 표심의 숨겨진 진실
          </a>
        </RelatedArticle>
        <RelatedArticle>
          <a href="https://news.sbs.co.kr/news/endPage.do?news_id=N1006635299">
            누가 와도 1위는 확정? 철옹성 동네 대해부
          </a>
        </RelatedArticle>
      </WrapLink>
    </>
  );
}
